import React, { useState, useEffect, useRef } from "react";
import styles from "./LoginPage.module.css";
import loginImage from "../../assets/images/loginImage.png";
import { loginApi } from "../../config/loginApi";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";
import {connect} from 'react-redux';
import changeLogin from '../../store/Actions/LoginAction';

function LoginPage(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const btn = useRef();

  const history = useHistory();

  // const emailValidation = /^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/;
  const emailValidation = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  // const passwordValidation = /^[A-Za-z[0-9]\w{7,}$/;

  const handleLogin = (e) => {
    e.preventDefault();

    if (emailValidation.test(email) === false) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{marginRight: "10px"}} />
          Please Enter Valid Email Address!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else if (!(password.length > 7 && password.length <21)) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{marginRight: "10px"}} />
          Please Enter Valid Password!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else {
      setLoading(true);
      btn.current.setAttribute("disabled", "disabled");
      const login = async () => {
        const login = await loginApi(email, password);

        if (login.error) {
          if (
            login.error.response.data.message ===
            "Account details supplied is incorrect, please check and try again"
          ) {
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{marginRight: "10px"}} />
                Wrong Email Or Password!
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );

            setLoading(false);
            btn.current.removeAttribute("disabled");

            setPassword("");
          } else {
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{marginRight: "10px"}} />
                {login.error.response.data.message}
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );

            setLoading(false);
            btn.current.removeAttribute("disabled");
          }
        } else if (login.data) {
          toast.success(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BsCheckAll size="30" style={{marginRight: "10px"}} />
              Login Successfully
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
          setEmail("");
          setPassword("");

          setLoading(false);
          btn.current.removeAttribute("disabled");

          props.ChangeLogin(true)

          setTimeout(function () {
            history.push("/");
          }, 1000);
        }
      };
      login();
    }
  };


  return (
    <div className={styles.mainall}>
      <div className={styles.main}>
        <img src={loginImage} alt="Main Image" className={styles.loginImage} />
        <div className={styles.formCont}>
          <h1 className={styles.heading}>Welcome</h1>
          <p className={styles.des}>
            Visapro is your most reliable and contactless visa processing
            partner.
          </p>
          <form onSubmit={(e) => handleLogin(e)}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              className={styles.input}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              className={styles.input}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit" className={styles.login} ref={btn}>
              {loading ? (
                <div class="spinner-border" role="status"></div>
              ) : (
                "Login"
              )}
            </button>
          </form>
          <div className={styles.allgo}>
            <p className={styles.next}>
              Not registered?{" "}
              <Link to="/register" className={styles.go}>
                Sign up here
              </Link>
            </p>
            <p className={styles.next}>
              Forgot password?{" "}
              <Link to="/forgot-password" className={styles.go}>
                Click here
              </Link>
            </p>
          </div>
        </div>
      </div>
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
      {/* <div className="spinner-grow spinner-grow-sm" role="status"></div> */}
    </div>
  );
}


const mapStateToProps = (state) => ({
  login: state.Login.login,
});

const mapDispatchToProp = (dispatch) => ({
  ChangeLogin: (login) => dispatch(changeLogin(login)),
});

export default connect(mapStateToProps,mapDispatchToProp)(LoginPage);